export default [
    {
        path: "unidad-medida",
        name: "unidadesMedida",
        component: () => import(/* webpackChunkName: "gestionUnidadesMedida" */ "./unidadesMedida.vue"),
    }
]